import React from 'react';
import { Layout } from '../components/Layout';

const AvisoPrivacidad: React.FC = () => {
  return (
    <Layout
      title="Aviso de Privacidad Integral de kamdata®"
      description="Aviso de Privacidad Integral de kamdata® vigente a partir del 30 de mayo de 2026."
      keywords="aviso de privacidad integral kamdata datos personales derechos arco"
      canonicalUrl="https://www.kamdata.com.mx/aviso-de-privacidad"
    >
      <section className="bg-gradient-to-br from-kamdata-primary/10 to-kamdata-accent/10 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-sm font-semibold text-kamdata-primary uppercase tracking-wide mb-3">
            Documento legal
          </p>
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Aviso de Privacidad Integral de kamdata®
          </h1>
          <p className="text-xl text-gray-600">
            Última actualización: 30 de mayo de 2026.
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none text-gray-700">
            <p>
              En cumplimiento con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP), su Reglamento y los Lineamientos del Aviso de Privacidad emitidos por el INAI, se pone a su disposición el presente Aviso de Privacidad Integral:
            </p>

            <h2>1. Responsable del Tratamiento de sus Datos Personales</h2>
            <p>
              La persona física Karla María Martínez Lemus, quien opera comercialmente bajo la marca kamdata®, con Registro Federal de Contribuyentes (RFC) MALK8004098N6, y con domicilio establecido para oír y recibir notificaciones en la ciudad de León, Guanajuato, México, es la responsable del uso, almacenamiento, protección y tratamiento legítimo de sus datos personales.
            </p>

            <h2>2. Datos Personales que se Recaban</h2>
            <p>
              Para llevar a cabo las finalidades descritas en el presente documento, recabamos sus datos de forma directa cuando usted nos los proporciona a través de nuestros formularios de registro, solicitudes de servicio, sitio web, WhatsApp o de forma presencial durante el desarrollo de las sesiones. Los datos que tratamos son:
            </p>
            <ul>
              <li>Datos de Identificación: Nombre completo.</li>
              <li>Datos de Contacto: Cuenta de correo electrónico, número de teléfono celular (WhatsApp) y perfiles en redes sociales profesionales (si aplica).</li>
              <li>Datos Laborales y del Negocio: Nombre de su empresa o proyecto comercial, giro o actividad industrial, puesto o cargo, así como información general sobre las necesidades o retos operativos de su negocio.</li>
              <li>Datos de Imagen y Voz: Grabaciones de audio, video y capturas de pantalla tomadas durante el desarrollo de las sesiones virtuales, talleres o mentorías.</li>
              <li>Datos Fiscales (Facturación): Nombre o Razón Social, RFC, Régimen Fiscal y Código Postal contenidos en su Constancia de Situación Fiscal (únicamente si solicita CFDI).</li>
            </ul>
            <p>
              Aclaración de Datos Sensibles: kamdata® no solicita, ni trata bajo ninguna circunstancia, datos personales de carácter sensible (tales como origen étnico, estado de salud, creencias religiosas, filosóficas o morales, afiliación sindical u opiniones políticas).
            </p>

            <h2>3. Finalidades del Tratamiento de los Datos</h2>
            <p>
              Los datos personales recabados serán utilizados para las siguientes finalidades:
            </p>

            <h3>A. Finalidades Primarias (Necesarias para la existencia, cumplimiento y mantenimiento de la relación jurídica):</h3>
            <ul>
              <li>Verificar y confirmar su identidad para el proceso de cotización, inscripción y contratación.</li>
              <li>Gestionar su alta como cliente en nuestros programas de mentoría, talleres o servicios contratados.</li>
              <li>Darle acceso a las sesiones virtuales, herramientas tecnológicas, materiales de apoyo y grabaciones.</li>
              <li>Grabar las sesiones en línea y mentorías grupales o individuales, aceptación que el cliente otorga desde el momento de su solicitud o contratación, con la finalidad exclusiva de integrar el material didáctico del propio servicio para consulta del cliente, así como para procesos internos de evaluación, soporte técnico y control de calidad en el servicio prestado.</li>
              <li>Mantener canales de comunicación directos para el seguimiento de los servicios, envío de recordatorios de sesiones y atención de dudas.</li>
              <li>Realizar la cobranza y emitir los comprobantes fiscales (facturas) solicitados.</li>
            </ul>

            <h3>B. Finalidades Secundarias (Fines mercadotécnicos o publicitarios):</h3>
            <ul>
              <li>Enviarle información sobre nuevas mentorías, convocatorias, talleres, seminarios y programas desarrollados por kamdata®.</li>
              <li>Hacerle llegar boletines informativos, actualizaciones tecnológicas y artículos de interés para su negocio.</li>
              <li>Realizar encuestas de satisfacción generales.</li>
            </ul>
            <p>
              Derecho de Oposición a Finalidades Secundarias: Si usted no desea que sus datos personales sean tratados para las finalidades secundarias, puede manifestar su negativa desde este momento enviando un correo electrónico a{' '}
              <a href="mailto:informes@kamdata.com.mx" className="text-kamdata-primary underline">
                informes@kamdata.com.mx
              </a>
              . Su negativa no será motivo para negarle los servicios principales que contrate con nosotros.
            </p>

            <h2>4. Transferencia de sus Datos Personales</h2>
            <p>
              kamdata® se compromete a no vender, arrendar, regalar o transferir sus datos personales a terceros ajenos para fines comerciales o publicitarios.
            </p>
            <p>
              Sus datos únicamente podrán ser compartidos con:
            </p>
            <ul>
              <li>Proveedores de Servicios Tecnológicos: Empresas que actúan como encargadas del tratamiento de datos (plataformas de almacenamiento en la nube, infraestructura para videoconferencias, procesadores de pago, software de envío de correos masivos o herramientas de formularios), las cuales operan bajo estrictas políticas de confidencialidad equivalentes a las nuestras.</li>
              <li>Autoridades Competentes: En los casos previstos por el Artículo 37 de la LFPDPPP, o cuando exista un requerimiento judicial o mandamiento de autoridad competente debidamente fundado y motivado.</li>
            </ul>

            <h2>5. Medios para Ejercer los Derechos ARCO y Revocación del Consentimiento</h2>
            <p>
              Usted tiene derecho en todo momento a Acceder a sus datos personales, Rectificarlos en caso de ser inexactos o incompletos, Cancelarlos cuando considere que no se requieren para las finalidades señaladas, u Oponerse al tratamiento de los mismos para fines específicos (Derechos ARCO). Asimismo, puede Revocar el consentimiento que nos haya otorgado previamente.
            </p>
            <p>
              Para el ejercicio de cualquiera de estos derechos, deberá enviar una solicitud formal por escrito al correo electrónico:{' '}
              <a href="mailto:informes@kamdata.com.mx" className="text-kamdata-primary underline">
                informes@kamdata.com.mx
              </a>
              , la cual deberá contener:
            </p>
            <ol>
              <li>Su nombre completo y medio para comunicarle la respuesta (correo electrónico).</li>
              <li>Copia de su identificación oficial vigente (INE o Pasaporte) para acreditar su identidad.</li>
              <li>La descripción clara y precisa de los datos personales respecto de los cuales busca ejercer alguno de los derechos ARCO.</li>
              <li>Cualquier otro elemento o documento que facilite la localización de sus datos.</li>
            </ol>
            <p>
              kamdata® atenderá y resolverá su solicitud en un plazo máximo de 20 (veinte) días hábiles contados a partir de su recepción, en términos de lo dispuesto por la Ley. Las partes de común acuerdo reconocen que se entenderán por días hábiles todos los días de cada año calendario que (i) no sean sábado o domingo, (ii) no sean un día de descanso obligatorio en los términos previstos en el artículo 74 de la Ley Federal del Trabajo y (iii) no sean un día inhábil aplicable a entidades financieras sujetas a la supervisión de la Comisión Nacional Bancaria y de Valores que esta última determine mediante sus publicaciones oficiales.
            </p>

            <h2>6. Mecanismos de Seguridad y Uso de Tecnologías Digitales</h2>
            <p>
              Contamos con medidas de seguridad administrativas, técnicas y físicas necesarias para proteger sus datos personales contra daño, pérdida, alteración, destrucción o el uso, acceso o tratamiento no autorizado.
            </p>
            <p>
              Le informamos que en nuestro sitio web podemos utilizar cookies u otras tecnologías web para analizar el tráfico de navegación y mejorar su experiencia de usuario; sin embargo, estas herramientas recolectan datos de forma estadística y anónima, no perfiles de identificación personal directa.
            </p>

            <h2>7. Modificaciones al Aviso de Privacidad</h2>
            <p>
              El presente Aviso de Privacidad puede sufrir modificaciones, cambios o actualizaciones derivadas de reformas legales, políticas internas o nuevas necesidades de nuestros servicios. Cualquier modificación estará disponible para su consulta a través de nuestro sitio web{' '}
              <a href="https://kamdata.com.mx" className="text-kamdata-primary underline">
                kamdata.com.mx
              </a>
              {' '}y mediante los documentos físicos o digitales que le hagamos llegar.
            </p>

            <p className="text-sm text-gray-500 border-t pt-6">
              © 2026 kamdata®. Todos los derechos reservados. Aviso de Privacidad Integral de kamdata®. Vigente a partir de su publicación y difusión el 30 de mayo de 2026.{' '}
              <a href="mailto:informes@kamdata.com.mx" className="text-kamdata-primary underline">informes@kamdata.com.mx</a>
              {' '}| +52 56 6161 0375 | kamdata.com.mx
            </p>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default AvisoPrivacidad;
